import React, { useState, useEffect } from 'react';
import { bizConfig } from '../../../utils/bizConfig';
import Loading from '../../../components/Loading';
import CardInput from '../../../components/Card';
import CardInputNok from '../../../components/CardNok';
import SimpleSelectInput from '../../../components/Input/SimpleSelect';
import Typography from '../../../components/Typography';
import { getData } from 'utils/token';
import styled from 'styled-components';
import CancelPopup from '../Popup/index'

const Header = styled.header`
  padding: 20px 0;  // Adicionando algum padding vertical
`;

const HeaderTitle = styled.div`
  margin-bottom: 20px;  // Espaço após o título
`;

const SelectContainer = styled.div`
  margin-bottom: 20px;  // Espaço após o select
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

function ListaFormulariosPage(props) {
    const { idProducao, setSelectedMenu, setIdFormulario, setNomeFormulario, setPeriodicidade, setPossuiPesagem, status, possuiPesagem, idFormularioEdicao, idSequenciaEdicao, setLancamentoPOSFinalizar } = props;
    const [formularios, setFormularios] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [acessosUsuario, setAcessosUsuario] = useState(null);
    const [turno, setTurno] = useState("");
    const [optionsTurnos, setOptionsTurnos] = useState(null);
    const userData = getData();
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [cancelReason, setCancelReason] = useState('');

    const ConsultarOptionTurnos = () => {
        let requestInfo = {
            method: 'POST',
            headers: bizConfig.requestHeaders,
            body: JSON.stringify([
                {
                    "nome": "cad_empresa",
                    "valor": bizConfig.cad_empresa
                },
                {
                    "nome": "cad_filial",
                    "valor": bizConfig.cad_filial
                },
                {
                    "nome": "tipo",
                    "valor": "ddl_inq_turnos"
                },
                {
                    "nome": "opcaoTodos",
                    "valor": "1"
                }
            ])
        };
        fetch(`${bizConfig.rootApi}/DropDown`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setOptionsTurnos(response)
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            })
    }

    if (idFormularioEdicao) {
        setSelectedMenu('apontamentosFormulario');
        setIdFormulario(idFormularioEdicao);
    }

    useEffect(() => {
        if (!idProducao) return;
        setShowLoader(true);
        ConsultarFormularios();
    }, [idProducao]);

    useEffect(() => {
        ConsultarOptionTurnos();
    }, []);

    useEffect(() => {
        if (!idProducao) return;
        setShowLoader(true);
        ConsultarFormularios();
    }, [turno]);

    const ConsultarFormularios = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };
        fetch(`${bizConfig.rootApi}/InqProducaoFormularios/${bizConfig.cad_empresa}/${bizConfig.cad_filial}/${idProducao}/${userData.usuario}/${turno || ""}`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setFormularios(response);
                ConsultarAcessosUsuario();
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            })
    }

    const ConsultarAcessosUsuario = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };
        fetch(`${bizConfig.rootApi}/InqAcessosProducao/${bizConfig.cad_empresa}/${bizConfig.cad_filial}/${idProducao}/${userData.usuario}`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setAcessosUsuario(response);
                setShowLoader(false);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            })
    }

    const GerarDossie = () => {
        setShowLoader(true);
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };
        fetch(`${bizConfig.rootApi}/Dossie/${bizConfig.cad_empresa}/${bizConfig.cad_filial}/${idProducao}/${status}`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setShowLoader(false);
                var timeStampInMs = window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now();
                window.location.assign(response.arquivo + "?" + timeStampInMs);
                console.log(response);
            })
            .catch((error) => {
                setShowLoader(false);
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            })
    }

    const alterarStatusLancamento = (operacao, motivoCancelamento) => {
        setShowLoader(true);
        let requestInfo = {
            method: 'POST',
            headers: bizConfig.requestHeaders,
            body: JSON.stringify(
                {
                    "cad_empresa": bizConfig.cad_empresa,
                    "cad_filial": bizConfig.cad_filial,
                    "inq_id_producao": idProducao,
                    "operacao": operacao,
                    "prd_referencia": "",
                    "prd_codigo": "",
                    "inq_id_linha": "",
                    "inq_lote": "",
                    "inq_data_acondicionamento": "",
                    "inq_data_validade_lote": "",
                    "inq_motivo_cancelamento": motivoCancelamento,
                    "inq_usuario": userData.usuario,
                    "inq_motivo_alteracao": "Finalizando produção",
                    "inq_id_status_producao": "",
                    "inq_id_turno": "",
                    "inq_unificador_lote": "",
                    "inq_dun_1": "",
                    "inq_dun_2": "",
                    "inq_dun_3": "",
                    "inq_qrcode_1": "",
                    "inq_qrcode_2": "",
                    "inq_qrcode_3": ""
                }
            )
        };
        fetch(`${bizConfig.rootApi}/InqProducao`, requestInfo)
            .then(response => {

                if (response.status === 200 || response.status === 400) {
                    return response;
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setShowLoader(false);
                window.location.href = '/#/lista-producao/' + status;
            })
            .catch((error) => {
                setShowLoader(false);
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            })
    }

    return (
        <>
            <Loading show={showLoader} size="big" />
            <Header>
            <HeaderTitle>
                <Typography variant="h3" >Formulários</Typography>

                </HeaderTitle>

                <SelectContainer>
                                        {optionsTurnos && <SimpleSelectInput
                        id="turno"
                        name="turno"
                        label="Turno"
                        options={optionsTurnos.map(item => (<option value={item.codigo}>{item.display}</option>))}
                        onChange={(e) => {
                            setTurno(e?.props?.value);
                        }}
                    />}

                </SelectContainer>

                <ButtonsContainer className='cardsProducaoX'>
                    { !bizConfig.online && status == 'IN' && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].novaProducao == 1) &&
                        <a
                            className='b-1 p-1 ml-1'
                            style={{ cursor: 'pointer' }}
                            href={"/#/producao-editar/" +
                                idProducao + '/' +
                                possuiPesagem + '/' +
                                status
                            }
                        >
                            Alterar produção
                        </a>
                    }
                    { bizConfig.online && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].gerarDossie == 1) &&
                        <a
                            className='b-1 p-1 ml-1'
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                GerarDossie();
                            }}
                        >
                            Gerar Dossiê
                        </a>
                    }
                    { !bizConfig.online && status == 'IN' && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].finalizarLancamentos == 1) &&
                        <a
                            className='b-1 p-1 ml-1'
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                alterarStatusLancamento(4, "");
                            }}
                        >
                            Finalizar lançamentos
                        </a>
                    }
                    {!bizConfig.online &&
                        status == 'IN' &&
                        acessosUsuario &&
                        acessosUsuario.length > 0 &&
                        acessosUsuario[0].cancelarProducao == 1 && (
                            <a
                                className="b-1 p-1 ml-1"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setIsPopupOpen(true)}
                            >
                                Cancelar produção
                            </a>
                        )}
                    <CancelPopup
                        isOpen={isPopupOpen}
                        onClose={() => setIsPopupOpen(false)}
                        onSubmit={(reason) => {
                            setCancelReason(reason);
                            setIsPopupOpen(false);
                            alterarStatusLancamento(3, reason);
                        }}
                    />
                    { !bizConfig.online && status == 'FI' && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].revisarLancamentos == 1) &&
                        <a
                            className='b-1 p-1 ml-1'
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                alterarStatusLancamento(5, "");
                            }}
                        >
                            Revisar lançamentos
                        </a>
                    }
                    {!bizConfig.online && status == 'FI' && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].finalizarLancamentos == 1) &&
                        <a
                            className='b-1 p-1 ml-1'
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                alterarStatusLancamento(6, "");
                            }}
                        >
                            Arquivar Produção
                        </a>
                    }
                    <a
                        className='b-1 p-1 ml-1'
                        style={{ cursor: 'pointer' }}
                        href={"/#/lista-producao/" + status}
                    >
                        Voltar
                    </a>
                </ButtonsContainer>

            </Header>
            <div className={'cardsProducao'}>
                {
                    (acessosUsuario && acessosUsuario.length > 0 && acessosUsuario[0].cadastrarCubas == 1 &&
                     acessosUsuario && acessosUsuario.length > 0 && acessosUsuario[0].possuiCubas == 0 &&
                        <CardInputNok
                            key={`card-formulario-000`}
                            children={
                                (
                                    <>
                                        IT#053 anexo I - TROCA DE CUBA / BAG / BEEN / CONTAINER / ISOTANK / CHEP / FI / TANQUE
                                        {!bizConfig.online && <a
                                            style={{ marginTop: ".4em" }}
                                            onClick={() => {
                                                setSelectedMenu('cuba');
                                                setIdFormulario('000');
                                                setNomeFormulario('Cubas');
                                                setPeriodicidade('');
                                                setPossuiPesagem('');
                                                setLancamentoPOSFinalizar(0);
                                            }}
                                        >
                                            Entrar
                                        </a>}
                                    </>
                                )
                            }
                        />)
                    ||
                    (acessosUsuario && acessosUsuario.length > 0 && acessosUsuario[0].cadastrarCubas == 1 &&
                     acessosUsuario && acessosUsuario.length > 0 && acessosUsuario[0].possuiCubas == 1 &&
                        <CardInput
                            key={`card-formulario-000`}
                            children={
                                (
                                    <>
                                        IT#053 anexo I - TROCA DE CUBA / BAG / BEEN / CONTAINER / ISOTANK / CHEP / FI / TANQUE
                                        {!bizConfig.online && <a
                                            style={{ marginTop: ".4em" }}
                                            onClick={() => {
                                                setSelectedMenu('cuba');
                                                setIdFormulario('000');
                                                setNomeFormulario('Cubas');
                                                setPeriodicidade('');
                                                setPossuiPesagem('');
                                                setLancamentoPOSFinalizar(0);
                                            }}
                                        >
                                            Entrar
                                        </a>}
                                    </>
                                )
                            }
                        />)
                }
                {
                    formularios.map((element, index) => (
                        (element.inq_pendente == 0 &&
                            <CardInput
                                key={`card-formulario-${index}`}
                                children={
                                    (
                                        <>
                                            {element.inq_nome_formulario}
                                            {!bizConfig.online && <a
                                                style={{ marginTop: ".4em" }}
                                                onClick={() => {
                                                    setSelectedMenu('apontamentosFormulario');
                                                    setIdFormulario(element.inq_id_formulario);
                                                    setNomeFormulario(element.inq_nome_formulario);
                                                    setPeriodicidade(element.inq_periodicidade);
                                                    setPossuiPesagem(element.inq_possui_pesagem);
                                                    setLancamentoPOSFinalizar(element.inq_lancamento_pos_finalizar);
                                                }}
                                            >
                                                Entrar
                                            </a>}
                                        </>
                                    )
                                }
                            />)
                        ||
                        (element.inq_pendente == 1 &&
                            <CardInputNok
                                key={`card-formulario-${index}`}
                                children={
                                    (
                                        <>
                                            {element.inq_nome_formulario}
                                            {!bizConfig.online && <a
                                                style={{ marginTop: ".4em" }}
                                                onClick={() => {
                                                    setSelectedMenu('apontamentosFormulario');
                                                    setIdFormulario(element.inq_id_formulario);
                                                    setNomeFormulario(element.inq_nome_formulario);
                                                    setPeriodicidade(element.inq_periodicidade);
                                                    setPossuiPesagem(element.inq_possui_pesagem);
                                                    setLancamentoPOSFinalizar(element.inq_lancamento_pos_finalizar);
                                                }}
                                            >
                                                Entrar
                                            </a>}
                                        </>
                                    )
                                }
                            />)

                    )
                    )
                }

            </div>
        </>
    );
}

export default ListaFormulariosPage;